import { categoryUnreads } from '@/api/message';
import { userHabitQuery, userHabitRecord } from '@/api/user';

export default {
  namespaced: true,
  state: {
    unreadInfo:{
      comment: 0,
      responsible: 0,
      follow: 0,
      automation_station_msg: 0,
      sys: 0
    },
    onlySeeUnread: false,
    currentTab: null
  },
  getters: {
    getUnreadCount: (state) => type => state.unreadInfo[type] || 0,
    unreadCount: state => Object.values(state.unreadInfo).reduce((acc, c) => acc + c || 0, 0)
  },
  mutations: {
    /**
     * 设置消息类型的未读条数
     * @param state
     * @param info
     */
    setUnreadInfo(state, info) {
      Object.keys(state.unreadInfo).forEach(key => {
        state.unreadInfo[key] = info?.[key] || 0;
      });
    },
    /**
     * 设置是否只看未读
     * @param state
     * @param value
     */
    setOnlySeeUnread(state, value) {
      state.onlySeeUnread = value;
    },
    /**
     * 设置当前标签页
     * @param state
     * @param value
     */
    setCurrentTab(state, value) {
      state.currentTab = value;
    }
  },
  actions: {
    /**
     * 刷新未读信息
     * @param commit
     * @returns {Promise<void>}
     */
    async refreshUnreadInfo({ commit }) {
      const unreadInfo = await categoryUnreads();
      commit('setUnreadInfo', unreadInfo);
    },
    /**
     * 设置是否只看未读
     * @param rootState
     * @param commit
     * @param value
     * @returns {Promise<void>}
     */
    async changeOnlySeeUnread({ rootState, commit }, value) {
      await userHabitRecord({
        linkIdList: [value],
        linkType: 'messageOnlyUnRead',
        projectId: 0,
        userId: rootState.user.account?.userId
      });
      commit('setOnlySeeUnread', value);
    },
    /**
     * 刷新是否只看未读
     * @param rootState
     * @param commit
     * @returns {Promise<void>}
     */
    async refreshOnlySeeUnread({ rootState, commit }, init){
      if (this.inited && init) {
        return;
      }
      const res = await userHabitQuery({
        linkType: 'messageOnlyUnRead',
        projectId: 0,
        userId: rootState.user.account?.userId
      });
      const [value] = res?.result?.linkIdList || [];
      commit('setOnlySeeUnread', value === true || value === 'true' ? true : false);
      this.inited = true;
    }
  }
};
